import { render, staticRenderFns } from "./DialogNotificacao.vue?vue&type=template&id=66f87067"
import script from "./DialogNotificacao.vue?vue&type=script&lang=js"
export * from "./DialogNotificacao.vue?vue&type=script&lang=js"
import style0 from "./DialogNotificacao.vue?vue&type=style&index=0&id=66f87067&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports